<template>
  <div>
    <div
      class="fe-flex fe-justify-between fe-items-center fe-text-heading-xxs lg:fe-text-heading-xs fe-mb-s lg:fe-mb-m"
    >
      <div>Overall Rating</div>
      <div>Write a Review</div>
    </div>
    <div class="fe-grid fe-grid-cols-3 fe-gap-xs lg:fe-gap-base">
      <div class="fe-col-span-1">
        <RatingStats />
      </div>
      <div class="fe-col-span-2">
        <RatingHistogram maxProgressBars="5" />
      </div>
    </div>
  </div>
</template>

<script>
  import RatingHistogram from "./RatingHistogram.two.vue"
  import RatingStats from "./RatingStats.two.vue"

  export default {
    name: "RatingSummary",
    components: {
      RatingStats,
      RatingHistogram,
    },
  }
</script>
